import { LayerType } from '../models/layer-type';

export const layerTypeLabelMap = new Map<LayerType, string>([
  [LayerType.WMS, 'WMS'],
  [LayerType.WFS, 'WFS'],
]);
